import { LanguageProvider } from './lib/i18n';
import { ThemeProvider } from './lib/ThemeContext';
import { FontProvider } from './lib/FontContext';
import AppRoutes from './routes';

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <FontProvider>
          <AppRoutes />
        </FontProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App; 
